if (!window.cip_Entity) {
    window.cip_Entity = {};
}
if (!window.cc_EntityIntegration) {
    window.cc_EntityIntegration = {};
}
if (!window.cc_UI) {
    window.cc_UI = {};
}
if (!window.cc_View) {
    window.cc_View = {};
}
if (!window.cc_Renderer) {
    window.cc_Renderer = {};
}
if (!window.cc_Icon) {
    window.cc_Icon = {};
}
if (!window.cip_StatusServer) {
    window.cip_StatusServer = {};
}
if (!window.cip_StatusController) {
    window.cip_StatusController = {};
}
if (!window.cip_StatusWidget) {
    window.cip_StatusWidget = {};
}
if (!window.cip_StatusUI) {
    window.cip_StatusUI = {};
}
if (!window.cip_StatusCommentDialog) {
    window.cip_StatusCommentDialog = {};
}
if (!window.cip_StatusDocumentDialog) {
    window.cip_StatusDocumentDialog = {};
}
if (!window.cip_SaveAsDialog) {
    window.cip_SaveAsDialog = {};
}
if (!window.cip_SendSmsCodeDialog) {
    window.cip_SendSmsCodeDialog = {};
}
if (!window.cip_ActivateUsingSmsCodeDialog) {
    window.cip_ActivateUsingSmsCodeDialog = {};
}
if (!window.cip_ActivateUsingCustomerDetails) {
    window.cip_ActivateUsingCustomerDetails = {};
}
if (!window.cip_Custom) {
    window.cip_Custom = {};
}
if (!window.cc_Analytics) {
    window.cc_Analytics = {};
}